/* ==========================================================================
   as-dial-codes.js
   The dialling codes, in one place.

   Shared by every form on the site that asks for a phone number — the
   back-in-stock waitlist and the BF26 early access page — because two copies
   of 212 countries drift the moment one of them is edited.

   "name|ISO|dial". US, UK and CA are pinned to the top: they are the markets.
   The rest follow alphabetically, matching the country selector in the
   header.

   Held as a flat array and built into options only when a form actually needs
   them. A 212-option <select> rendered server-side into every sold-out tile
   would be thousands of nodes on a grid.
   ========================================================================== */

(function () {
  'use strict';

  var CODES = [
    'United States|US|1',
    'United Kingdom|GB|44',
    'Canada|CA|1',
    'Afghanistan|AF|93',
    'Albania|AL|355',
    'Algeria|DZ|213',
    'Andorra|AD|376',
    'Angola|AO|244',
    'Anguilla|AI|1',
    'Antigua & Barbuda|AG|1',
    'Argentina|AR|54',
    'Armenia|AM|374',
    'Aruba|AW|297',
    'Australia|AU|61',
    'Austria|AT|43',
    'Azerbaijan|AZ|994',
    'Bahamas|BS|1',
    'Bahrain|BH|973',
    'Bangladesh|BD|880',
    'Barbados|BB|1',
    'Belarus|BY|375',
    'Belgium|BE|32',
    'Belize|BZ|501',
    'Benin|BJ|229',
    'Bermuda|BM|1',
    'Bhutan|BT|975',
    'Bolivia|BO|591',
    'Bosnia & Herzegovina|BA|387',
    'Botswana|BW|267',
    'Brazil|BR|55',
    'Brunei|BN|673',
    'Bulgaria|BG|359',
    'Burkina Faso|BF|226',
    'Burundi|BI|257',
    'Cambodia|KH|855',
    'Cameroon|CM|237',
    'Cape Verde|CV|238',
    'Cayman Islands|KY|1',
    'Central African Republic|CF|236',
    'Chad|TD|235',
    'Chile|CL|56',
    'China|CN|86',
    'Colombia|CO|57',
    'Comoros|KM|269',
    'Congo - Brazzaville|CG|242',
    'Congo - Kinshasa|CD|243',
    'Costa Rica|CR|506',
    'Croatia|HR|385',
    'Cuba|CU|53',
    'Curaçao|CW|599',
    'Cyprus|CY|357',
    'Czechia|CZ|420',
    'Côte d’Ivoire|CI|225',
    'Denmark|DK|45',
    'Djibouti|DJ|253',
    'Dominica|DM|1',
    'Dominican Republic|DO|1',
    'Ecuador|EC|593',
    'Egypt|EG|20',
    'El Salvador|SV|503',
    'Equatorial Guinea|GQ|240',
    'Eritrea|ER|291',
    'Estonia|EE|372',
    'Eswatini|SZ|268',
    'Ethiopia|ET|251',
    'Fiji|FJ|679',
    'Finland|FI|358',
    'France|FR|33',
    'French Guiana|GF|594',
    'French Polynesia|PF|689',
    'Gabon|GA|241',
    'Gambia|GM|220',
    'Georgia|GE|995',
    'Germany|DE|49',
    'Ghana|GH|233',
    'Gibraltar|GI|350',
    'Greece|GR|30',
    'Greenland|GL|299',
    'Grenada|GD|1',
    'Guadeloupe|GP|590',
    'Guatemala|GT|502',
    'Guernsey|GG|44',
    'Guinea|GN|224',
    'Guinea-Bissau|GW|245',
    'Guyana|GY|592',
    'Haiti|HT|509',
    'Honduras|HN|504',
    'Hong Kong SAR|HK|852',
    'Hungary|HU|36',
    'Iceland|IS|354',
    'India|IN|91',
    'Indonesia|ID|62',
    'Iraq|IQ|964',
    'Ireland|IE|353',
    'Isle of Man|IM|44',
    'Israel|IL|972',
    'Italy|IT|39',
    'Jamaica|JM|1',
    'Japan|JP|81',
    'Jersey|JE|44',
    'Jordan|JO|962',
    'Kazakhstan|KZ|7',
    'Kenya|KE|254',
    'Kiribati|KI|686',
    'Kosovo|XK|383',
    'Kuwait|KW|965',
    'Kyrgyzstan|KG|996',
    'Laos|LA|856',
    'Latvia|LV|371',
    'Lebanon|LB|961',
    'Lesotho|LS|266',
    'Liberia|LR|231',
    'Libya|LY|218',
    'Liechtenstein|LI|423',
    'Lithuania|LT|370',
    'Luxembourg|LU|352',
    'Macao SAR|MO|853',
    'Madagascar|MG|261',
    'Malawi|MW|265',
    'Malaysia|MY|60',
    'Maldives|MV|960',
    'Mali|ML|223',
    'Malta|MT|356',
    'Martinique|MQ|596',
    'Mauritania|MR|222',
    'Mauritius|MU|230',
    'Mexico|MX|52',
    'Moldova|MD|373',
    'Monaco|MC|377',
    'Mongolia|MN|976',
    'Montenegro|ME|382',
    'Montserrat|MS|1',
    'Morocco|MA|212',
    'Mozambique|MZ|258',
    'Myanmar (Burma)|MM|95',
    'Namibia|NA|264',
    'Nauru|NR|674',
    'Nepal|NP|977',
    'Netherlands|NL|31',
    'New Caledonia|NC|687',
    'New Zealand|NZ|64',
    'Nicaragua|NI|505',
    'Niger|NE|227',
    'Nigeria|NG|234',
    'North Macedonia|MK|389',
    'Norway|NO|47',
    'Oman|OM|968',
    'Pakistan|PK|92',
    'Palestinian Territories|PS|970',
    'Panama|PA|507',
    'Papua New Guinea|PG|675',
    'Paraguay|PY|595',
    'Peru|PE|51',
    'Philippines|PH|63',
    'Poland|PL|48',
    'Portugal|PT|351',
    'Qatar|QA|974',
    'Romania|RO|40',
    'Russia|RU|7',
    'Rwanda|RW|250',
    'Réunion|RE|262',
    'Samoa|WS|685',
    'San Marino|SM|378',
    'Saudi Arabia|SA|966',
    'Senegal|SN|221',
    'Serbia|RS|381',
    'Seychelles|SC|248',
    'Sierra Leone|SL|232',
    'Singapore|SG|65',
    'Sint Maarten|SX|1',
    'Slovakia|SK|421',
    'Slovenia|SI|386',
    'Solomon Islands|SB|677',
    'Somalia|SO|252',
    'South Africa|ZA|27',
    'South Korea|KR|82',
    'South Sudan|SS|211',
    'Spain|ES|34',
    'Sri Lanka|LK|94',
    'St. Kitts & Nevis|KN|1',
    'St. Lucia|LC|1',
    'St. Vincent & Grenadines|VC|1',
    'Sudan|SD|249',
    'Suriname|SR|597',
    'Sweden|SE|46',
    'Switzerland|CH|41',
    'São Tomé & Príncipe|ST|239',
    'Taiwan|TW|886',
    'Tajikistan|TJ|992',
    'Tanzania|TZ|255',
    'Thailand|TH|66',
    'Timor-Leste|TL|670',
    'Togo|TG|228',
    'Tonga|TO|676',
    'Trinidad & Tobago|TT|1',
    'Tunisia|TN|216',
    'Turkmenistan|TM|993',
    'Turks & Caicos Islands|TC|1',
    'Tuvalu|TV|688',
    'Türkiye|TR|90',
    'Uganda|UG|256',
    'Ukraine|UA|380',
    'United Arab Emirates|AE|971',
    'Uruguay|UY|598',
    'Uzbekistan|UZ|998',
    'Vanuatu|VU|678',
    'Vatican City|VA|39',
    'Venezuela|VE|58',
    'Vietnam|VN|84',
    'Yemen|YE|967',
    'Zambia|ZM|260',
    'Zimbabwe|ZW|263'
  ];;

  var template = null;

  /*
    TWO LABELS FOR ONE OPTION.

    A closed <select> shows the selected option's own text, so the full
    "GB +44 — United Kingdom" is truncated to "G…" in a box narrow enough to
    leave room for the number. The long label is what makes the open list
    scannable, so both are kept and swapped: long while choosing, short once
    chosen.
  */
  function fragment() {
    if (template) return template;

    template = document.createDocumentFragment();
    CODES.forEach(function (row) {
      var parts = row.split('|');
      var option = document.createElement('option');
      option.value = '+' + parts[2];
      option.dataset.iso = parts[1];
      option.dataset.full = parts[1] + ' +' + parts[2] + ' \u2014 ' + parts[0];
      option.dataset.short = parts[1] + ' +' + parts[2];
      option.textContent = option.dataset.full;
      template.appendChild(option);
    });

    return template;
  }

  /*
    Fills a <select> once, selects the wanted country, and keeps the label
    short while closed. Safe to call again — it leaves a filled select alone.
  */
  function fill(select, iso) {
    if (!select || select.options.length) return;

    select.appendChild(fragment().cloneNode(true));

    var shorten = function () {
      var picked = select.options[select.selectedIndex];
      if (picked) picked.textContent = picked.dataset.short;
    };
    var lengthen = function () {
      var picked = select.options[select.selectedIndex];
      if (picked) picked.textContent = picked.dataset.full;
    };

    select.addEventListener('mousedown', lengthen);
    select.addEventListener('focus', lengthen);
    select.addEventListener('change', shorten);
    select.addEventListener('blur', shorten);

    if (iso) {
      for (var i = 0; i < select.options.length; i++) {
        if (select.options[i].dataset.iso === iso) {
          select.selectedIndex = i;
          break;
        }
      }
    }

    shorten();
  }

  window.AsDialCodes = { codes: CODES, fragment: fragment, fill: fill };
})();
